export default __webpack_public_path__ + "static/media/rms-qr-code-app-icon.e8825e55.svg";